import type { Icon } from "@phosphor-icons/react";
import type { ReactNode } from "react";

export default function PreviewItemRow({
  icon: Icon,
  label,
  children,
}: {
  icon: Icon;
  label: string;
  children: ReactNode;
}) {
  return (
    <div className="flex items-center p-3 gap-x-3 bg-black-50 first:rounded-t-3xl last:rounded-b-3xl border-b border-b-black-150 last:border-b-0">
      <span className="text-white bg-black-800 p-1.5 shadow-[0_2.571px_5.143px_1.714px_rgba(17,24,39,0.20)] rounded-xl">
        <Icon size={16} />
      </span>

      <span className="flex-1 text-sm-bold">{label}</span>

      {children}
    </div>
  );
}
